import { makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Page } from 'src/components';
import TaxCertificateForm from './components/TaxCertificateForm';

const useStyles = makeStyles(() => ({
  root: {
    padding: '1em'
  }
}));
export const CreateTaxCertificationView: FC = () => {
  const classes = useStyles();
  return (
    <Page className={classes.root} title="Tax Certification">
      <Typography color="textPrimary" gutterBottom variant="h3">
        Create Tax Certification
      </Typography>
      <TaxCertificateForm isCreatePage />
    </Page>
  );
};
